import React from "react";

export class ErrorContext extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error(error, errorInfo);
    }

    onReload() {
        window.location.reload();
    }

    render() {
        // @ts-ignore
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: "column",
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: "center",
                    width: '100%',
                    height: "100%"
                }}>
                    <p style={{fontSize: 16}}>Something went wrong please try again later!</p>
                    <button onClick={() => this.onReload()}>
                        Try again
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

